import { render, staticRenderFns } from "./ServiceStatistics.vue?vue&type=template&id=62691ad2&scoped=true&"
import script from "./ServiceStatistics.vue?vue&type=script&lang=js&"
export * from "./ServiceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ServiceStatistics.vue?vue&type=style&index=0&id=62691ad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62691ad2",
  null
  
)

export default component.exports